import { Wording } from '@/types';

export const PILATES_WORDING_LT: Wording = {
  components_header_media_content: 'Treniruotės',
  components_header_media_1: '',
  components_header_media_2: '',
  components_header_text1: 'Receptai',
  components_header_text2: 'Dienoraštis',
  components_header_members: 'nariai',
  hero_text: 'Laikykite savo kūną lankstų ir tvirtą',
  hero_button_text: 'Pradėkite savo pilateso kelionę',
  components_ressources_section_title: 'IŠTEKLIAI',
  components_ressources_subheader_text:
    'Visi ištekliai, kurių jums reikia harmoningam gyvenimo būdui',
  components_ressources_span_text:
    'Atraskite sveikatingumo paslaptis: pasinerkite į Pilateso pratimų ir naudingų receptų kolekciją, kad sukurtumėte pusiausvyrą visuose savo gyvenimo aspektuose.',
  components_ressources_card_1_title: 'Pilateso patarimai',
  components_ressources_card_1_text:
    'Praktiniai patarimai, kaip pagilinti savo praktiką ir tobulinti savo kasdienybę.',
  components_ressources_card_2_title: 'Dieta',
  components_ressources_card_2_text:
    'Protingos mitybos patarimai, kad būtumėte sveikesni ir stipresni.',
  components_ressources_link: 'Žiūrėti vaizdo įrašus',
  components_notes_and_google_title_1: 'Pilatesas',
  components_notes_and_google_title_2: 'Reguliari rutina',
  components_notes_and_google_title_3: 'Dietos palaikymas',
  components_review_google_text: 'Peržiūrėkite „Google“.',
  media_content_section_title: 'TRENIRUOTĖS',
  media_content_section_subheader_text: 'Mūsų vaizdo įrašai',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Daugiau vaizdo įrašų',
  text2_section_title: 'BLOGAS',
  text2_section_subheader_text: 'Straipsniai ir naujienos',
  text2_section_button_more: 'Daugiau straipsnių',
  components_text1_section_title: 'RECEPTAI',
  components_text1_subheader_text: 'Maitinkite savo kūną ir protą',
  components_text1_span_text:
    'Naudingi receptai, padėsiantys atlikti pilateso pratimus ir pagerinti savijautą.',
  components_text1_card_1_title: 'Energiją suteikiantys pusryčiai',
  components_text1_card_1_text:
    'Pabuskite valgydami energingus, energiją suteikiančius patiekalus.',
  components_text1_card_3_title: 'Energingi pietūs',
  components_text1_card_3_text:
    'Atraskite skanių ir patogių pietų receptų, skirtų jūsų aktyviam gyvenimo būdui. Nuo spalvingų salotų iki baltymų kupinų įvyniojimų – šie receptai leis jums pailsėti ir sutelkti dėmesį.',
  components_text1_card_2_title: 'Vakarienės atsigavimui',
  components_text1_card_2_text:
    'Išbandykite įvairius liesus baltymus, nesmulkintus grūdus ir energingas daržoves, kad dieną užbaigtumėte sočiai.',
  components_text1_link: 'Žiūrėti visus receptus',
  components_footer_text:
    'Raskite pusiausvyrą, giliai kvėpuokite: jūsų pilatesas, jūsų kelionė.',
  components_footer_info: 'Informacija',
  components_footer_registration_number: 'Registracijos numeris',
  components_footer_legal: 'Teisinė',
  components_footer_terms: 'Taisyklės ir sąlygos',
  components_footer_privacy: 'Privatumo politika',
  button_load_more: 'Įkelti daugiau',
  page_media_1_content_hero_text: 'Pilateso treniruotės',
  page_text1_hero_text: 'Receptai',
  page_text1_section_title: 'Mityba',
  page_text1_subheader_text: 'Receptai',
  page_text2_hero_text: 'Mūsų tinklaraštis',
  page_text2_section_title: 'Dienoraštis',
  page_text2_subheader_text: 'Straipsniai ir naujienos',
  enter_email_title: 'Norėdami tęsti, įveskite savo el. pašto adresą',
  enter_email_placeholder_email: 'El. paštas',
  enter_email_button_enter: 'Įeikite',
  components_login_success_text: 'Prisijungimas sėkmingas!',
  components_card_link_media_content: 'Žiūrėti dabar',
  components_card_link_text1_content: 'Žiūrėti receptą',
  components_card_link_text2_content: 'Žiūrėti straipsnį',
  france: 'Prancūzija',
  cyprus: 'Kipras',
};
